import Vue from 'vue'
import {mapGetters} from 'vuex'
import cfg from '../../public/static/cfg'
import store from './store'

const socketInit = function () {
  let host = cfg.socket.server
  let webSocket = new WebSocket(host + '/?token=' + store.getters.token)
  webSocket.onmessage = socketOnMessage // webSocket 绑定事件处理
  webSocket.onopen = function(evt) { 
    console.log("socket opened"); 
  };
  webSocket.onclose = e => {
    // console.error(e)
    socket.$bus.emit('socketOff') // 交给 app.vue 处理
  }
  webSocket.onerror = e => {
    // console.error(e)
  }
  return webSocket
}

const socketOnMessage = function (event) {
  let act = /(.*?)\((.*)\)/.exec(event.data)[1]
  let para = /(.*?)\((.*)\)/.exec(event.data)[2]
  switch (act) {
  case socket.EVENT.WRAPPER:
    onWrapper(para)
    return
  // case socket.EVENT.SYNC:
  //   onSync(para)
  //   return
  // case socket.EVENT.CLOSE:
  //   store.commit('status', socket.STATUS.Waiting)
  //   break
  // case socket.EVENT.ERROR:
  //   if (store.state.status === socket.STATUS.Asking || store.state.status === socket.STATUS.BeAsking) {
  //     store.commit('status', socket.STATUS.Waiting)
  //   }
  //   break
  // case socket.EVENT.OFF:
  //   store.commit('status', socket.STATUS.Waiting)
  //   break
  // case socket.EVENT.REQUEST:
  //   para = JSON.parse(/,(.*)/.exec(para)[1])
  //   store.commit('status', socket.STATUS.BeAsking)
  //   break
  // case socket.EVENT.ACCEPT:
  //   para = JSON.parse(para)
  //   if (!para.isCallback) {
  //     store.commit('status', socket.STATUS.BeHelping)
  //   } else {
  //     store.commit('status', socket.STATUS.Helping)
  //   }
  //   break
  // case socket.EVENT.REFUSE:
  //   para = JSON.parse(para)
  //   store.commit('status', socket.STATUS.Waiting)
  //   break
  // case socket.EVENT.CANCEL:
  //   store.commit('status', socket.STATUS.Waiting)
  //   break
  // case socket.EVENT.CALLBACK:
  // case socket.EVENT.RTC_SDP:
  // case socket.EVENT.RTC_OFFER:
  // case socket.EVENT.RTC_ANSWER:
  // case socket.EVENT.RTC_REFRESH:
  // case socket.EVENT.RTC_READY:
  //   para = JSON.parse(para)
  //   break
  default:
    // store.commit('status', socket.STATUS.Waiting)
    break
  }
  // socket.$bus.emit(act, para)
}

let wrapMap = new Map()
// 收到包装
const onWrapper = function (data) {
  let wrapper = JSON.parse(data)
  if (wrapMap.has(wrapper.id)) {
    let msg = wrapMap.get(wrapper.id)
    msg = msg.replace('【【【' + wrapper.index + ']]]', wrapper.data)
    if (wrapper.total - 1 === wrapper.index) {
      wrapMap.delete(wrapper.id)
      msg = decodeURIComponent(msg)
      msg = msg.replace(/（（（（（/g, '(')
      msg = msg.replace(/）））））/g, ')')
      socketOnMessage({data: msg})
    } else {
      wrapMap.set(wrapper.id, msg)
    }
  } else {
    let msg = ''
    for (let i = 0; i < wrapper.total; i++) {
      msg = msg + '【【【' + i + ']]]'
    }
    msg = msg.replace('【【【' + wrapper.index + ']]]', wrapper.data)
    wrapMap.set(wrapper.id, msg)
  }
}

// // 收到同步
// let syncString = ''
// const onSync = function (data) {
//   if (store.getters.isBeHelping) {
//     data = data.replace(/（（（（（/g, '(')
//     data = data.replace(/）））））/g, ')')
//     let command = {}
//     try {
//       command = JSON.parse(data)
//     } catch (error) {
//       try {
//         syncString += data
//         command = JSON.parse(syncString)
//         syncString = ''
//       } catch (error) {
//         return
//       }
//     }

//     switch (command.action) {
//     case 'go':
//       socket.$router.isSync = true
//       socket.$router.push({name: command.name, query: command.query})
//       break
//     case 'sync':
//       socket.$bus.emit('sync-' + command.name, command)
//       break
//     default:
//       break
//     }
//   }
// }

const socket = new Vue({
  // router,
  store: store,
  data () {
    return {
      webSocket: null
    }
  },
  computed: {
    ...mapGetters([
      'setting',
      // 'setting',
      // 'status',
      // 'isHelping',
      // 'isBeHelping',
      // 'isSingleDoctor'
    ])
  },
  created: function () {
    this.EVENT = {
      WRAPPER: 'WRAPPER',
      // REQUEST: 'REQUEST',
      // CANCEL: 'CANCEL',
      // ACCEPT: 'ACCEPT',
      // REFUSE: 'REFUSE',
      // CLOSE: 'CLOSE',
      // ERROR: 'ERROR',
      // SYNC: 'SYNC',
      // OFF: 'OFF',
      // RTC_SDP: 'RTC_SDP',
      // RTC_OFFER: 'RTC_OFFER',
      // RTC_ANSWER: 'RTC_ANSWER',
      // RTC_REFRESH: 'RTC_REFRESH',
      // RTC_READY: 'RTC_READY'
    }
    // this.STATUS = {
    //   Waiting: 0,
    //   Asking: 1,
    //   BeAsking: 2,
    //   Helping: 3,
    //   BeHelping: 4
    // }
  },
  methods: {
    install (Vue) {
      Vue.prototype.$socket = this
    },
    connect () { // 登录
      // if (!user || !user.code) {
      //   this.$message.error('当前用户未设置，Socket登录取消!')
      //   return false
      // }
      if (!this.webSocket || this.webSocket.readyState !== 1) {
        this.webSocket = socketInit()
      }
      return true
    },
    disconnect () { // 登出
      try {
        this.webSocket.close()
        this.webSocket = null
      } catch (e) {
        console.log(e)
      }
      // this.$store.commit('status', socket.STATUS.Waiting)
    },
    // request (code, request) { // 申请
    //   this.$store.commit('status', socket.STATUS.Asking)
    //   this.send(this.EVENT.REQUEST + '(' + code + ',' + JSON.stringify(request) + ')')
    // },
    // cancel () { // 取消
    //   if (this.status === socket.STATUS.Asking) {
    //     this.send(this.EVENT.CANCEL + '()')
    //     this.$store.commit('status', socket.STATUS.Waiting)
    //   }
    // },
    // accept (treatment) { // 同意
    //   if (this.status === socket.STATUS.BeAsking) {
    //     this.send(this.EVENT.ACCEPT + '(' + JSON.stringify(treatment) + ')')
    //     if (!treatment.isCallback) {
    //       this.$store.commit('status', socket.STATUS.Helping)
    //     } else {
    //       this.$store.commit('status', socket.STATUS.BeHelping)
    //     }
    //   }
    // },
    // refuse (info) { // 拒绝
    //   if (this.status === socket.STATUS.BeAsking) {
    //     this.send(this.EVENT.REFUSE + '(' + JSON.stringify(info) + ')')
    //     this.$store.commit('status', socket.STATUS.Waiting)
    //   }
    // },
    // close () { // 完诊
    //   // store.commit('clearTreatment')
    //   if (this.isHelping && !this.isSingleDoctor) {
    //     this.send(this.EVENT.CLOSE + '()')
    //     this.$store.commit('status', socket.STATUS.Waiting)
    //   }
    // },
    // sync (command) { // 同步
    //   if (this.isHelping && !this.isSingleDoctor) {
    //     this.send(this.EVENT.SYNC + '(' + command + ')')
    //   }
    // },
    send (msg) { // 发送消息（共通）
      const maxSize = 6000
      try {
        if (!this.webSocket || this.webSocket.readyState !== this.webSocket.OPEN) {
          console.log("can not send since socket diconnected!")          
          return
        }
        if (msg.length <= maxSize) {
          this.webSocket.send(msg)
        } else {
          msg = msg.replace(/\(/g, '（（（（（')
          msg = msg.replace(/\)/g, '）））））')
          msg = encodeURIComponent(msg)
          let id = new Date().getTime()
          let times = parseInt(msg.length / maxSize) + 1
          for (let i = 0; i < times; i++) {
            let data = msg.substr(i * maxSize, maxSize)
            this.webSocket.send(this.EVENT.WRAPPER + '({"id":' + id + ', "total":' + times + ', "index":' + i + ', "data":"' + data + '"})')
          }
        }
      } catch (err) {
        console.error(err)
      }
    }
  }
})

export default socket
